import { useSelector } from 'react-redux'

import {
  selectCockpitPartnerClassOptions,
  selectCockpitUserAccess,
} from '../../../../model/selectors'
import { CockpitPartnerSearchFilter } from '../cockpitPartnerSearchFilter/CockpitPartnerSearchFilter'

import { CockpitAmplifyMembershipFilter } from './components/cockpitAmplifyMembershipFilter/CockpitAmplifyMembershipFilter'
import { CockpitGeoMappingFilter } from './components/cockpitGeoMappingFilter/CockpitGeoMappingFilter'
import { CockpitGlobalPartnerFilter } from './components/cockpitGlobalPartnerFilter/CockpitGlobalPartnerFilter'
import { CockpitManagerField } from './components/cockpitManagerField/CockpitManagerField'
import { CockpitMandatoryStatusFilter } from './components/cockpitMandatoryStatusFilter/CockpitMandatoryStatusFilter'
import { CockpitMdfStatusFilter } from './components/cockpitMdfStatusFilter/CockpitMdfStatusFilter'
import { CockpitPartnerClassFilter } from './components/cockpitPartnerClassFilter/CockpitPartnerClassFilter'
import { CockpitPbmField } from './components/cockpitPbmField/CockpitPbmField'
import { CockpitPlannedFilter } from './components/cockpitPlannedFilter/CockpitPlannedFilter'

import styles from './CockpitFilterOptions.module.scss'

export const CockpitFilterOptions = ({ unified = false }: { unified?: boolean }) => {
  const { role: userRoleId } = useSelector(selectCockpitUserAccess)
  const isPartnerManager = userRoleId === 'P360PartnerManager'
  const isSalesManager = userRoleId === 'P360SalesManager'
  const showPbmFilter = !isPartnerManager
  const showManagerFilter = !isPartnerManager && !isSalesManager
  const showPartnerClassFilter = useSelector(selectCockpitPartnerClassOptions).length > 0

  if (unified) {
    return (
      <div className={styles.unified}>
        <CockpitMandatoryStatusFilter />
        <CockpitPartnerSearchFilter />
        <div className={styles.group}>
          <CockpitGeoMappingFilter hideLabel />
          {showPartnerClassFilter && <CockpitPartnerClassFilter dropdown />}
        </div>
        {(showPbmFilter || showManagerFilter) && (
          <div className={styles.group}>
            {showPbmFilter && <CockpitPbmField hideLabel />}
            {showManagerFilter && <CockpitManagerField hideLabel />}
          </div>
        )}
        <div className={styles.group}>
          <CockpitAmplifyMembershipFilter dropdown />
          <div className={styles.switchers}>
            <CockpitMdfStatusFilter />
            <CockpitPlannedFilter />
          </div>
          <CockpitGlobalPartnerFilter hideLabel />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <CockpitMandatoryStatusFilter />
      <div className={styles.divider} />
      {showPbmFilter && (
        <>
          <CockpitPbmField />
          <div className={styles.divider} />
        </>
      )}
      {showManagerFilter && (
        <>
          <CockpitManagerField />
          <div className={styles.divider} />
        </>
      )}
      <CockpitGeoMappingFilter />
      <div className={styles.divider} />
      {showPartnerClassFilter && (
        <>
          <CockpitPartnerClassFilter />
          <div className={styles.divider} />
        </>
      )}
      <CockpitAmplifyMembershipFilter />
      <div className={styles.divider} />
      <CockpitMdfStatusFilter />
      <div className={styles.divider} />
      <CockpitPlannedFilter />
      <div className={styles.divider} />
      <CockpitGlobalPartnerFilter />
      <div className={styles.divider} />
    </div>
  )
}
